












import { Component, Prop, Vue } from "vue-property-decorator";
import teacherTab from "./teacherTab/index.vue";
import teacherAndStudent from "./teacherAndStudent/index.vue";
import { PageModule } from "@/store/module/page";

@Component({
  components: {
    teacherTab,
    teacherAndStudent,
  },
})
export default class extends Vue {
  activeName = "teacher";
  created() {
    const tab = PageModule.pageInfo.teacherAndStudent;
    if (tab.tab_Info) {
      this.activeName = tab.tab_Info;
    }
  }
  handleClick(tab: any) {
    PageModule.SET_PAGE_INFO({
      name: "teacherAndStudent",
      key: "tab_Info",
      value: tab._props.name,
    });
  }
}
